<template>
  <v-card
    :color="color"
    width="300"
    class="v-sheet theme--light mx-0"
    elevation="2"
  >
    <v-card-title class="text-uppercase justify-center">
      <p class="text-no-wrap">{{ title }}</p>
    </v-card-title>
    <v-row justify="center" class="ma-n10">
      <v-col cols="12" sm="6" align="center">
        <v-card-subtitle>{{ $t("AdminPage.used") }}</v-card-subtitle>
        <h3>{{ used }}</h3>
      </v-col>
      <v-col cols="12" sm="6" align="center">
        <v-card-subtitle>{{ $t("AdminPage.free") }}</v-card-subtitle>
        <h3>{{ free }}</h3>
      </v-col>
    </v-row>
    <v-card-text>
      <v-progress-linear
        :color="color"
        :value="ratio"
        height="5"
        class="mt-3"
      />
    </v-card-text>
  </v-card>
</template>

<script>
function hexToRgbA(hex) {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + ",0.25)"
    );
  }
  throw new Error("Bad Hex");
}
/**
 * @vue-prop {String} title - card title
 * @vue-prop {Number} used - stores how many items are used
 * @vue-prop {Number} free - stores how many items are free
 * @vue-prop {Number} ratio - stores free/used ratio
 * @vue-data {String} mainColor - stores the main color
 * @vue-computed {} textStyle() - stores the text color
 */
export default {
  name: "license-card",
  props: {
    title: String,
    used: Number,
    free: Number,
    ratio: Number,
  },
  data() {
    return {
      color: "",
    };
  },
  created() {
    this.color = hexToRgbA(this.$vuetify.theme.themes.light.primary);
  },
};
</script>
